/* tslint:disable */
/* eslint-disable */
/**
 * BFF Web Product
 * API reference used to call the backend from the web frontend
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { UpsellSettingsDto } from './upsell-settings-dto';

/**
 * 
 * @export
 * @interface EditOfferAfterPurchaseSettingsDto
 */
export interface EditOfferAfterPurchaseSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof EditOfferAfterPurchaseSettingsDto
     */
    'redirectType': EditOfferAfterPurchaseSettingsDtoRedirectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EditOfferAfterPurchaseSettingsDto
     */
    'redirectUrl'?: string | null;
    /**
     * 
     * @type {UpsellSettingsDto}
     * @memberof EditOfferAfterPurchaseSettingsDto
     */
    'upsell': UpsellSettingsDto | null;
}

/**
    * @export
    * @enum {string}
    */
export enum EditOfferAfterPurchaseSettingsDtoRedirectTypeEnum {
    USER_GROUPS = 'user_groups',
    MEMBERS_AREA = 'members_area',
    EXTERNAL_URL = 'external_url',
    UPSELL = 'upsell'
}


